var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"}},[_c('div',[_c('span',{directives:[{name:"b-modal",rawName:"v-b-modal.comment",modifiers:{"comment":true}}],staticClass:"fa fa-comment-dots"})])])}
var staticRenderFns = []

export { render, staticRenderFns }